/**
 * Carousel Map
 * https://swiperjs.com/
 */

// import Swiper from 'swiper';

import Swiper from "Vendor/swiper.js";
import $ from "jquery";

let carouselMap = undefined;

export default function carousel() {
  // When Carousel exists
  if (carousel) {
    $(document).ready(function () {
      $("#m-f-map").on("show.bs.modal", function () {
        $(".img-resize").resizeToParent();
        setTimeout(function () {
          var carouselMap = new Swiper(".carousel-map", {
            slidesPerView: 1,
            spaceBetween: 8,
          });
        }, 500);
      });
    });
  }
}
